import "./popUp"
import "./typography"
import "./color"

import "../scss/main.scss"